import * as React from 'react';
import type { SVGProps } from 'react';

const SvgVideoPlay = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 96 96" {...props}>
    <path
      fill="currentColor"
      d="M48 6.862c22.68 0 41.138 18.459 41.138 41.138 0 22.68-18.459 41.138-41.138 41.138C25.32 89.172 6.862 70.713 6.862 48 6.862 25.287 25.321 6.862 48 6.862ZM48 0C21.512 0 0 21.512 0 48c0 26.487 21.512 48 48 48 26.522 0 48-21.513 48-48C96 21.512 74.522 0 48 0Z"
    />
    <path
      fill="currentColor"
      d="M41.339 32.971a3.005 3.005 0 0 0-3.122 3.02v24.154c0 2.299 2.607 3.774 4.563 2.573l20.14-12.077c1.921-1.166 1.921-4.014 0-5.18L42.78 33.382c-.446-.24-.926-.412-1.441-.412Z"
    />
  </svg>
);

export default SvgVideoPlay;
